import { TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';

function ModalUpdateManufacturers(props) {
  const { 
    editString,
    manufacturerStr,
    manufacturerDescriptionStr,
    manufacturerNameStr,
    saveStr
  } = useTranslationHook();

  const manufacturerName = localStorage.getItem('manufacturerNameForUpdate')
  const manufacturerDescription = localStorage.getItem('manufacturerDescriptionForUpdate')
  const manufacturerId = localStorage.getItem('manufacturerIdForUpdate')

  const [id, setId] = useState(manufacturerId);
  const [name, setName] = useState(manufacturerName);
  const [description, setDescription] = useState(manufacturerDescription);

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Equipo actualizado exitosamente en la base de datos.' });
    props.getManufacturers();
  }

  function resetFormFields() {
    setName(localStorage.getItem('manufacturerNameForUpdate'));
    setDescription(localStorage.getItem('manufacturerDescriptionForUpdate'));
  }
  
  //Update Manufacturers
  async function manageManufacturerUpdate(e) {
    e.preventDefault();
    try {
        await customAxios
        .patch(`${GlobalVariables.getURL()}manufacturers/update/${id}`,{
          name: name,
          description: description === null ? ' ' : description,
        }, {
          headers: {
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        })
        hide()
    } catch (error) {
        console.log("🚀 ~ manageManufacturerUpdate ~ error:", error)
    }
  }

  return (
    <Modal
        onEntering={resetFormFields}
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
        {editString + " " + manufacturerStr.charAt(0).toLowerCase() + manufacturerStr.slice(1)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='manufacturers-form' onSubmit={(e) => manageManufacturerUpdate(e)}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={manufacturerNameStr}
                type='text'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br/>

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={manufacturerDescriptionStr}
                type='text'
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button type='submit' form='manufacturers-form' className='save-modal-button'>
          {saveStr}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUpdateManufacturers;
